interface IconProps {
    width?: number;
    height?: number;
}

export default function LogOutIcon({ width = 20, height = 20 }: IconProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}>
            <title />
            <g id="Layer_1">
                <line
                    x1="7.6"
                    x2="22"
                    y1="12"
                    y2="12"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round" />
                <path
                    d="M11.9,0.8H4.5C3.1,0.8,2,1.9,2,3.2v17.5c0,1.4,1.1,2.5,2.5,2.5h7.4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round" />
                <polyline
                    points="18.2,8.2 22,12 18.2,15.8"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round" />
            </g>
            <g id="frame">
                <rect fill="none" height="24" width="24" />
            </g>
        </svg>
    )
}